import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import React from "react"
import { Chip, makeStyles, Tooltip } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(3),
        textAlign: 'center'
    },
    avatarIcon: {
        backgroundColor: "gray"
    },
    chipElement: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    whatsAppIcon: {
        color: "green"
    },
    mailIcon: {
        color: "red"
    }
}))

const ChipContact = (props) => {
    const classes = useStyles()

    const openWhatsApp = (number) => {
        let numberClean = number.replace(/[^A-Z0-9]/ig, "")
        window.open(`https://wa.me/55${numberClean}`, "_blank")
    }

    const copyToClipBoard = (value) => {
        navigator.clipboard.writeText(value)
    }

    const buildContactChip = (contact) => {
        let message = "copiar o contato"
        let icon = null
        let fun = null

        if (contact.type === "WHATSAPP") {
            message = "abrir o whatsapp"
            icon = <WhatsAppIcon className={classes.whatsAppIcon} />
            fun = openWhatsApp
        }

        if (contact.type === "MAIL") {
            icon = <MailOutlineIcon className={classes.mailIcon} />
            fun = copyToClipBoard
        }

        if (contact.type === "PHONE" || contact.type === "CELLPHONE") {
            icon = <PhoneAndroidIcon className={classes.mailIcon} />
            fun = copyToClipBoard
        }

        return (
            <Tooltip title={message} arrow>
                <Chip
                    className={classes.chipElement}
                    variant="outlined"
                    color="secondary"
                    label={contact.description}
                    icon={icon}
                    onClick={() => fun(contact.description)} />
            </Tooltip>
        )
    }

    return (
        <div>
            {
                props.contacts !== null ?
                props.contacts.map((contact) => (
                    buildContactChip(contact)
                )) : "Contato Não Informado"
            }
        </div>
    )


}

export default ChipContact